/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_TypeInputs */

const cs_deal_payments_type = /** @type {(inputs: Deal_Payments_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const en_deal_payments_type = /** @type {(inputs: Deal_Payments_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Deal_Payments_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_type = /** @type {((inputs?: Deal_Payments_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_type(inputs)
	return cs_deal_payments_type(inputs)
});